const GOOGLE_MAPS_BY_SHOP = {
    rs: { language: "sr-Latn", region: "RS", country: "rs" },
    ba: { language: "sr-Latn", region: "BA", country: "ba" },
    hr: { language: "hr", region: "HR", country: "hr" },
    si: { language: "sl", region: "SI", country: "si" },
};

export const GOOGLE_MAPS_LOAD = {
    key: "AIzaSyA6CVsNgn7ZZTGggvJC8dH2y-Aj5-T_PoM",
    libraries: "places",
    language: GOOGLE_MAPS_BY_SHOP.rs.language,
    region: GOOGLE_MAPS_BY_SHOP.rs.region,
};

export function googleMapsConfigForShop(countryLocale) {
    return GOOGLE_MAPS_BY_SHOP[countryLocale] || GOOGLE_MAPS_BY_SHOP.rs;
}

export function applyGoogleMapsShopCountry(countryLocale) {
    const config = googleMapsConfigForShop(countryLocale);

    GOOGLE_MAPS_LOAD.language = config.language;
    GOOGLE_MAPS_LOAD.region = config.region;

    return config;
}
